import { AlertCircle, Clock } from 'lucide-react';

interface PendingPaymentInfoCardProps {
  paymentDeadline?: string;
  total?: number;
  onViewInstructions?: () => void;
}

export const PendingPaymentInfoCard = ({ 
  paymentDeadline,
  onViewInstructions 
}: PendingPaymentInfoCardProps) => {
  const handleViewInstructions = () => {
    // En un caso real, esto abriría instrucciones de pago
    if (onViewInstructions) {
      onViewInstructions();
    } else {
      alert('Ver instrucciones de pago');
    }
  };

  return (
    <div className="bg-[#FFF5F0] border-2 border-[#FF6A2A] rounded-[16px] p-5 shadow-sm">
      <div className="flex items-start gap-3 mb-4">
        <div className="w-10 h-10 bg-[#FF6A2A] rounded-full flex items-center justify-center flex-shrink-0">
          <AlertCircle className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1">
          <h3 className="font-bold text-[#111827] mb-1">Pago pendiente</h3>
          <p className="text-sm text-[#6B7280] leading-relaxed">
            Este boleto se activará cuando el pago sea confirmado.
          </p>
        </div>
      </div>

      <div className="bg-white/60 rounded-[12px] p-4 space-y-3">
        <div className="space-y-2 text-sm text-[#6B7280]">
          <div className="flex items-start gap-2">
            <span className="text-[#FF6A2A] flex-shrink-0 mt-0.5">•</span>
            <span>Tu boleto se activará cuando el pago sea confirmado.</span>
          </div>
          <div className="flex items-start gap-2">
            <span className="text-[#FF6A2A] flex-shrink-0 mt-0.5">•</span>
            <span>Tienes hasta 3 horas antes de la salida para completar el pago; después, el asiento se libera.</span>
          </div>
        </div>

        {paymentDeadline && (
          <div className="flex items-center gap-2 pt-3 border-t border-[#E5E7EB]">
            <Clock className="w-4 h-4 text-[#FF6A2A] flex-shrink-0" />
            <div className="flex-1">
              <p className="text-xs text-[#6B7280]">Fecha límite de pago</p>
              <p className="text-sm font-semibold text-[#111827]">{paymentDeadline}</p>
            </div>
          </div>
        )}
      </div>

      {onViewInstructions && (
        <button
          onClick={handleViewInstructions}
          className="w-full mt-4 py-2.5 border-2 border-[#FF6A2A] text-[#FF6A2A] font-semibold rounded-[12px] hover:bg-[#FF6A2A] hover:text-white transition-colors"
        >
          Ver instrucciones de pago
        </button>
      )}
    </div>
  );
};